import Keycloak from 'keycloak-js'

export async function connectKeycloak(Vue, { url, realm, clientId, refreshInSeconds = 30 } = {}) {
    const keycloakConfig = {
        url,
        realm,
        clientId
    }

    const keycloak = new Keycloak(keycloakConfig)

    Vue.$keycloak = keycloak

    const initOptions = {
        onLoad: 'login-required',
        useNonce: true,
        checkLoginIframe: false
    }

    return keycloak.init(initOptions)
    .then(authenticated => {
        console.log('auth: ' + authenticated)

        setInterval(() => {
            if (keycloak.authenticated) {
                keycloak.updateToken(900)
                .catch(() => {
                    keycloak.logout()
                })
            }
        }, refreshInSeconds * 1000)

        if (authenticated) {
            return keycloak
        } else {
            throw 'kc-connection-failed'
        }
    })
}